<template>
    <div class="pl-5 pt-2 border-top">
        <div v-for="(clip, index) in clipsCount">
            <div class="iform-row mt-5">
                <div class="row">
                    <div class="col-md-9 col-sm-12">
                        <div class="form-group d-inline-flex w-100">
                            <label class="input-label mr-3">Clip #{{ index + 1 }} Name</label>
                            <app-input
                                :id="`clips[${index}]title`"
                                :name="`clips[${index}][title]`"
                                placeholder="Clip name"
                                class="w-75"
                                :is-required="true"
                                :value="getAttributeByIndex(index, 'title')"
                                :error="errorsList[`clips.${index}.title`] ? errorsList[`clips.${index}.title`][0] : ''"
                            ></app-input>
                            <input v-if="isEditing === true && existingClipsList[index]" :value="existingClipsList[index].id" type="hidden" :name="`clips[${index}][id]`"/>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-9 col-sm-12">
                        <div class="form-group d-inline-flex w-100">
                            <label class="input-label mr-3">Clip #{{ index + 1 }} Description</label>
                            <app-textarea
                                :id="`clips[${index}]description`"
                                :name="`clips[${index}][description]`"
                                placeholder="Clip description"
                                rows="5"
                                autocomplete="off"
                                class="w-75"
                                :is-required="true"
                                :index="index"
                                :value="getAttributeByIndex(index, 'description')"
                                :error="errorsList[`clips.${index}.description`] ? errorsList[`clips.${index}.description`][0] : ''"
                                :liveCount="displayLiveCDown"
                                :maxLength="maxCharactersLimit"
                            ></app-textarea>
                        </div>
                        <div class="mb-5 characters ml-auto">Characters remaining: {{textLimit[index]}}</div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-9 col-sm-12">
                        <div class="form-group d-inline-flex w-100">
                            <label class="input-label mr-3">Upload Media Clip</label>

                            <div class="w-75 d-flex">
                                <input
                                    :id="`clips[${index}]file`"
                                    :ref="`clips-${index}-file`"
                                    :name="`clips[${index}][file]`"
                                    class="w-50"
                                    type="file"
                                    @change="handleFileInput($event, index)"
                                >
                                <div class="w-50 d-table image-preview">
                                        <video v-if="isVideo(getMediaNameByIndex(index))" 
                                        class="img-fluid h-100 rounded"
                                        :src="getMediaByIndex(index)" autoplay loop></video>
                                        <img 
                                            v-else
                                            :src="getMediaByIndex(index)" 
                                            class="img-fluid h-100 rounded"
                                            :id="`clips_${index}_file`"
                                        >
                                </div>
                                <help-block class="file-input-error" 
                                            :text="errorsList[`clips.${index}.file`] ? errorsList[`clips.${index}.file`][0] : ''"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row mt-2">
            <div class="col-md-6 col-sm-12">
                <div class="form-group">
                <button-set>
                    <app-button
                        v-if="maxLimitCheck()"
                        type="primary"
                        :prevent-default="true"
                        @click="addClip"
                    >
                        + Another clip
                    </app-button>
                     <app-button
                        v-if="minLimitCheck()"
                        type="error"
                        :prevent-default="true"
                        @click="removeClip"
                    >
                        Remove clip
                    </app-button>
                </button-set>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export const CLIPS_MAX_LIMIT = 10;
export const VIDEO_FILE_TYPES = ['mp4'];

export default {
    props: {
        isEditing: {
            type: Boolean,
            default: false
        },
        validationErrors: {
            type: String,
            default: ''
        },
        oldValues: {
            type: String,
            default: ''
        },
        clips: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            clipsCount: 1,
            oldInputValuesList: [],
            existingClipsList: [],
            maxCharactersLimit: 170,
            textLimit: []
        };
    },

    created() {
        this.setOldInputValuesList();
        this.setExistingClipsList();
    },

    methods: {
        displayLiveCDown(value, i){
            this.$set(this.textLimit, i, this.maxCharactersLimit - value.length);
        },


        setOldInputValuesList() {
            let clipInputValues  = JSON.parse(this.oldValues);
            if (clipInputValues) {
                this.clipsCount = clipInputValues.length;
                return this.oldInputValuesList = clipInputValues;
            }
        },

        setExistingClipsList() {
            let existingClips  = JSON.parse(this.clips);
            if (existingClips.length > 0) {
                this.oldInputValuesList.length 
                    ? this.clipsCount = this.oldInputValuesList.length 
                    : this.clipsCount = existingClips.length;

                return this.existingClipsList = existingClips;
            }
        },

        getAttributeByIndex(index, attribute) {
            if(this.oldInputValuesList[index]){
                return this.oldInputValuesList[index][attribute];
            } else if(this.existingClipsList[index] && this.existingClipsList[index][attribute]) {
                return this.existingClipsList[index][attribute];
            } else {
                return '';
            }
        },

        getMediaByIndex(index) {
            return this.existingClipsList[index] && this.existingClipsList[index].media
                ? this.existingClipsList[index].media_path 
                : ''
        },

        getMediaNameByIndex(index) {
            return this.existingClipsList[index] && this.existingClipsList[index].media
                ? this.existingClipsList[index].media 
                : ''
        },

        isVideo(filename){
            let clipFileExtension = filename.split('.').pop();
            return VIDEO_FILE_TYPES.includes(clipFileExtension);
        },

        handleFileInput(e, index) {
            let inputfile = e.target.files[0];
            let fileUrl = URL.createObjectURL(inputfile);

            let maxFileSize = 1048576; //1mB in bytes, the same set on BE

            if(inputfile.size > maxFileSize) {
                this.handleTooLargeFile(inputfile.size, maxFileSize, index);
                return;
            }

            if(this.existingClipsList[index]) {
                this.existingClipsList[index].media_path = fileUrl;
                this.existingClipsList[index].media = inputfile.name;
            } else {
                this.existingClipsList.push({
                    'media_path': fileUrl,
                    'media': inputfile.name,
                });
            }
        },

        handleTooLargeFile(fileSize, maxSize, clipIndex) {
            let fileReference = `clips-${clipIndex}-file`;

            this.$refs[fileReference][0].value = null;
            if(this.existingClipsList[clipIndex]) {
                this.existingClipsList[clipIndex].media_path = '';
            }
            
            alert('This file is too large. The file size is '
                + (fileSize/1024/1024).toFixed(2) + ' Mb. Maximum allowed size is '
                + maxSize/1024/1024 + ' Mb.');
        },

        addClip() {
            if(this.maxLimitCheck()) {
                this.clipsCount++;
            }
        },

        maxLimitCheck() {
            return this.clipsCount < CLIPS_MAX_LIMIT;
        },

        minLimitCheck() {
            return this.clipsCount > 1;
        },

        removeClip() {
            if(this.minLimitCheck()) {
                 if(this.existingClipsList.length === this.clipsCount) {
                     this.removeStoredItem();
                 }
                this.clipsCount--;
            }
        },

        removeStoredItem() {
            this.existingClipsList.pop();
        }
    },

    computed: {
        errorsList() {
            if (this.validationErrors.length > 0) {
                return JSON.parse(this.validationErrors);
            }
            return new Object();
        }
    }
};
</script>

<style scoped lang="scss">
.input-label {
    width: 30%;
}

.file-input-error {
    color: #dc3545;
    position: absolute;
    margin-top: 2rem;
}

.image-preview {
    z-index: 1;
}

.characters{
    width: 70% !important;
}
</style>
